import { IterationHistoryInterface } from 'Interfaces/BDPortalInterfaces/HistoryInterface';
import { useCallback, useEffect, useState } from 'react';
import { bdportalScreenServices } from 'services/bdportalScreenServices';

const HistoryTabLogic = (iterationId: number) => {
  const [iterationHistoryLoading, setIterationHistoryLoading] = useState<boolean>(false);
  const [iterationHistoryError, setIterationHistoryError] = useState<boolean>(false);
  const [iterationHistory, setIterationHistory] = useState<IterationHistoryInterface | null>(null);

  const getIterationHistory = useCallback(async (id: number, signal?: AbortSignal) => {
    setIterationHistoryLoading(true);
    try {
      const data = await bdportalScreenServices.getIterationHistory(id, signal);
      setIterationHistory(data);
    } catch (err) {
      console.log('Error while fetching the history data ', err);
      setIterationHistoryError(true);
    } finally {
      setIterationHistoryLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    getIterationHistory(iterationId, signal);

    return () => {
      controller.abort();
    };
  }, [iterationId, getIterationHistory]);

  return { iterationHistory, iterationHistoryLoading, iterationHistoryError };
};

export default HistoryTabLogic;
